<script>
  import OutlinedInput from '@/components/form/OutlinedInput.vue';
  import rules from '@/helpers/validation-rules';

  export default {
    name: 'SignUpVerifyPhone',

    components: { OutlinedInput },

    props: {
      model: {
        type: Object,
        required: true,
      },
    },

    data: () => ({
      rules,
    }),

    methods: {
      async sendPhoneVerificationCode() {
        await this.$store.dispatch('sendVerification', {
          phoneNumber: this.model.phone.countryCode + this.model.phone.number,
        });
      },
      handlePaste(event) {
        // Remove +1 and non-digit characters
        event.preventDefault();
        const paste = (event.clipboardData || window.clipboardData)
          .getData('text')
          .replace(/^\+1/, '')
          .replace(/\D/g, '');
        const formattedPaste = paste.startsWith('1') && paste.length > 10 ? paste.substring(1) : paste;

        document.execCommand('insertText', false, formattedPaste);
      },
    },
  };
</script>

<template>
  <div class="mt-6 d-flex flex-column align-center gap-24">
    <span class="font-size-14 white--text">We’ll send you a one-time verification code for confirmation.</span>

    <outlined-input
      label="Phone Number"
      data-test-id="phone-number-input"
      v-model="model.phone.number"
      v-mask="'(###) ###-####'"
      placeholder="(___) ___ ____"
      :rules="[rules.required(), rules.minLength(10)]"
      class="w-full"
      @paste="handlePaste"
    >
      <template #prepend-inner>
        <span class="prepend-number">+1</span>
      </template>
    </outlined-input>

    <action-button>
      <template #action="{ loading, clickHandler }">
        <v-btn
          class="golden-button w-full"
          data-test-id="send-verification-code-button"
          :loading="loading"
          @click="clickHandler(sendPhoneVerificationCode)"
        >
          Send Verification Code
        </v-btn>
      </template>
    </action-button>
  </div>
</template>

<style scoped lang="scss">
  .gap-24 {
    gap: 24px;
  }

  .prepend-number {
    font-size: 16px;
    color: white;
    margin-top: 4px;
  }
</style>
